import React, { useEffect, useMemo, useState } from 'react'
import { Card, Grid, Button, CircularProgress } from '@mui/material'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx'
import { useParams } from 'react-router-dom'
import history from 'history.js'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'
import { isValidPhone } from 'utils'
import { useStore } from 'app/store'

const useStyles = makeStyles(({ palette, ...theme }) => ({
  cardHolder: {
    background: '#1A2038',
    overflow: 'scroll',
  },
  card: {
    maxWidth: 650,
    borderRadius: 12,
    margin: '1rem',
    overflow: 'visible',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  socialButton: {
    width: '100%',
    '& img': {
      margin: '0 8px',
    },
  },
  labelLink: {
    color: palette.primary.main,
    textDecoration: 'underline',
  },
  phoneInput: {
    width: '100% !important',
    paddingTop: '10.5px !important',
    paddingBottom: '10.5px  !important',
  },
}))

const SignUp = () => {
  const [loading, setLoading] = useState(false)
  const [state, setState] = useState({})
  const classes = useStyles()
  const [message, setMessage] = useState('')
  const { token } = useParams();
  const { signupStore } = useStore()

useEffect(() => {
  setLoading(true)
  signupStore.validateSignupToken(token).then((data) => {
    setState({
      ...state,
      username: data.email,
      company_name: data.enterpriseName,
    })
    setLoading(false)
  })
}, [token])


  const handleChange = ({ target: { name, value } }) => {
    setState({
      ...state,
      [name]: value,
    })
  }

  const isPhoneNumberValid = useMemo(() => {
    return isValidPhone(state.phone_number)
  }, [state])

  let {
    username,
    company_name,
    given_name,
    family_name,
    phone_number,
  } = state

  const handleFormSubmit = async () => {
    try {
      setLoading(true)
      let formData = {
        email: username,
        username: username,
        firstName: given_name,
        lastName: family_name,
        phoneNumber: phone_number,
        companyName: company_name
      }

      await signupStore.createUser(formData, token);

      history.push('/signin')
    } catch (e) {
      setLoading(false)
      console.log(e)
      setMessage(e.message)
    }
  }

  return (
    <div
      className={clsx(
        'flex justify-center items-center  min-h-full-screen',
        classes.cardHolder
      )}
    >
      <Card className={classes.card}>
        <Grid container>
          <Grid item lg={5} md={5} sm={5} xs={12}>
            <div className="p-8 flex justify-center bg-light-gray items-center h-full">
              <img
                className="w-full"
                src="/assets/images/illustrations/posting_photo.svg"
                alt=""
              />
            </div>
          </Grid>
          <Grid item lg={7} md={7} sm={7} xs={12}>
            <div className="p-8 h-full">
              <ValidatorForm onSubmit={handleFormSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextValidator
                      className="mb-4 w-full"
                      variant="outlined"
                      size="small"
                      label="First Name"
                      onChange={handleChange}
                      name="given_name"
                      value={given_name || ''}
                      validators={['required']}
                      errorMessages={['Required']}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextValidator
                      className="mb-4 w-full"
                      variant="outlined"
                      size="small"
                      label="Last Name"
                      onChange={handleChange}
                      name="family_name"
                      value={family_name || ''}
                      validators={['required']}
                      errorMessages={['Required']}
                    />
                  </Grid>
                </Grid>
                <TextValidator
                  className="mb-4 w-full"
                  variant="outlined"
                  size="small"
                  label="Company Name"
                  onChange={handleChange}
                  name="company_name"
                  disabled
                  value={company_name || ''}
                  validators={['required']}
                  errorMessages={['Required']}
                />
                <TextValidator
                  className="mb-4 w-full"
                  variant="outlined"
                  size="small"
                  label="Email"
                  onChange={handleChange}
                  type="email"
                  disabled
                  name="username"
                  value={username || ''}
                  validators={['required', 'isEmail']}
                  errorMessages={['Required', 'Invalid email']}
                />
                <PhoneInput
                  enableSearch
                  inputClass={classes.phoneInput}
                  country="gb"
                  value={phone_number || ''}
                  onChange={(phone_number) =>
                    setState({ ...state, phone_number: `+${phone_number}` })
                  }
                  inputProps={{
                    name: 'phone_number',
                    required: true,
                  }}
                  isValid={(value) => isValidPhone(`+${value}`)}
                />
                {message && <p className="text-error">{message}</p>}
                <div className="flex items-center mt-4">
                  <div className="relative">
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={loading || !isPhoneNumberValid}
                      type="submit"
                    >
                      Sign Up
                    </Button>
                    {loading && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </div>
                </div>
              </ValidatorForm>
            </div>
          </Grid>
        </Grid>
      </Card>
    </div>
  )
}

export default SignUp
